import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Product from '@/pages/WareProduct'
import Solutions from '@/pages/Solutions'
import Dtability from '@/pages/Dtability'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/product',
      name: 'product',
      component: Product
    },
    {
      path: '/solutions',
      name: 'solutions',
      component: Solutions
    },
    {
      path: '/dtability',
      name: 'dtability',
      component: Dtability
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js